import React, { useState, useRef } from "react";
import { loginToken, GetUserRole } from "./../../reducers/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link, useLocation  } from 'react-router-dom';
import { useEffect } from "react";

const SSO = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search)
  const email = queryParams.get("email")
  const appkey = queryParams.get("appkey")

  const { isLoggedIn } = useSelector((state) => state.auth);

  console.log("email", email);
  console.log("appkey", appkey);

  if(email ==null  || appkey==null)
  {
    return <Navigate to="/login" />;
  }

    dispatch(loginToken(email, appkey))
    .then(() => {
      dispatch(GetUserRole()).then(() => {
        navigate("/request/all");
      });
    })
    .catch(() => {
    })


  if (isLoggedIn) {
    return <Navigate to="/" />;
  }
  
  return (
    <></>
  );
};


export default SSO;